/**
 * ÌTURA gift bar + product-page gift line (12 Oct 2026, Paul).
 *
 * The number of free gifts left is the live Shopify stock of the cart gift list. The page renders it
 * server-side (snippets/itura-gift-count.liquid); this script then reads the never-cached section
 * /?sections=itura-gift-config on every page view, when the tab comes back into view, and after the
 * cart changes, and repaints every counter on the page. One request per view, no app, no n8n.
 */
(function () {
  if (window.__ituraGiftBarBound) return;
  window.__ituraGiftBarBound = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MIN_GAP = 20 * 1000;
  var lastAt = 0;
  var pending = null;

  function text(el, units) {
    var tpl = units === 1 ? el.getAttribute('data-lead-one') : el.getAttribute('data-lead');
    var parts = (tpl || '{count} free gifts left').split('{count}');
    var p = el.querySelector('.itura-gift-count__text');
    if (!p) return;
    p.textContent = '';
    p.appendChild(document.createTextNode(parts[0] || ''));
    var strong = document.createElement('strong');
    strong.className = 'itura-gift-count__number';
    strong.setAttribute('data-itura-gift-units', '');
    strong.textContent = String(units);
    p.appendChild(strong);
    p.appendChild(document.createTextNode(parts.slice(1).join('{count}')));
  }

  function paint(config) {
    var counters = document.querySelectorAll('[data-itura-gift-count]');
    if (!counters.length) return;
    var live = config && config.live !== false && Array.isArray(config.offer);
    Array.prototype.forEach.call(counters, function (el) {
      if (!live) {
        var section = el.closest('.shopify-section--itura-gift-bar') || el.closest('[id^="shopify-section-"][id*="itura_gift_bar"]');
        (section || el).hidden = true;
        return;
      }
      var units = Math.max(0, parseInt(config.units, 10) || 0);
      var start = parseInt(config.start, 10) || parseInt(el.getAttribute('data-start'), 10) || 0;
      el.setAttribute('data-units', String(units));
      // 19 Oct 2026 (Paul): the product-page line goes away at zero instead of saying the gifts are claimed.
      if (el.hasAttribute('data-hide-done')) el.hidden = units <= 0;
      if (units > 0) {
        el.setAttribute('data-state', 'open');
        text(el, units);
      } else {
        el.setAttribute('data-state', 'done');
        var p = el.querySelector('.itura-gift-count__text');
        if (p) p.textContent = el.getAttribute('data-done') || 'All free gifts claimed';
      }
      var fill = el.querySelector('[data-itura-gift-fill]');
      if (fill) {
        var pct = start > 0 && units > 0 ? Math.min(100, Math.max(3, Math.round((units / start) * 100))) : 0;
        fill.style.width = pct + '%';
      }
    });
  }

  function refresh(force) {
    if (!document.querySelector('[data-itura-gift-count]')) return;
    if (pending) return;
    if (!force && Date.now() - lastAt < MIN_GAP) return;
    pending = fetch(root.replace(/\/$/, '') + '/?sections=itura-gift-config', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        var holder = document.createElement('div');
        holder.innerHTML = sections['itura-gift-config'] || '';
        var node = holder.querySelector('#itura-gift-config');
        if (!node) return;
        var config = JSON.parse(node.textContent);
        lastAt = Date.now();
        paint(config);
      })
      .catch(function () {})
      .then(function () {
        pending = null;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refresh(true); });
  } else {
    refresh(true);
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refresh(false);
  });
  // A gift just went into or out of this cart: the pool itself has not moved, but the drawer's refresh is a
  // natural moment to re-read, and keeps the number honest while the tab stays open for a long time.
  document.addEventListener('cart:change', function () { refresh(false); });
})();
